import EventsSec from "./EventsSec";

export default EventsSec;
